<script lang="ts">
  import IndividualTextElement from './IndividualTextElement.svelte';
  import {textElementsStore} from '../../../../services/animation/text-loader';
  import {getInstance} from '../../../../services/animation';
  import editorInstance from '../../../../lib/editor/editor';
  import {createHTMLTextElement} from '../../../../lib/editor/helpers';
  import {allTextElementsStore} from '../../../../services/animation/text-loader';
  import {templateFontStore} from '../../../../services/animation/font-loader';

  function addTextElement(e: any) {
    if (e) e.target.blur();
    editorInstance.history.addHistory('Create text element');
    const textElement = createHTMLTextElement('New Text Element');
    const referenceElement = $allTextElementsStore[0];
    if (referenceElement) {
      const dynamicElement = referenceElement.querySelector('.dynamic');
      if (dynamicElement) {
        const styles = window.getComputedStyle(dynamicElement);
        textElement.style.fontSize = styles.fontSize;
        let dynamicEl = textElement.querySelector('.dynamic') as HTMLElement;
        if (dynamicEl) {
          dynamicEl.style.fontSize = styles.fontSize;
          dynamicEl.style.lineHeight = styles.lineHeight;
        }
        if (styles.color === 'rgba(0, 0, 0, 0)') {
          textElement.style.color = 'rgba(0, 0, 0, 1)';
        } else {
          textElement.style.color = styles.color;
        }
        textElement.style.zIndex = '10';
        textElement.style.fontStyle = $templateFontStore[1];
        textElement.querySelector('.dynamic')?.classList.add('secondary-font');
        textElement.style.fontFamily = $templateFontStore[1];
      }
    }

    editorInstance.addComponent(textElement, true);
    // Recompute loaders
    getInstance().templateLoader.textLoader.identifyTextElements();
    getInstance().templateLoader.colorLoader.readColors();
    console.log('Text element added', textElement);
    setTimeout(() => {
      textElement.focus();
      textElement.click();
    }, 500);
  }
</script>

<div class="flex w-full flex-col gap-3">
  {#each $textElementsStore as element (element)}
    <IndividualTextElement {element} elText={element.innerText} />
  {/each}

  <button
    on:keypress={addTextElement}
    on:click={addTextElement}
    class="flex w-full items-center justify-center rounded-xl border border-dashed border-gray-300 bg-white px-2 py-3 hover:bg-zinc-300"
  >
    <i class="fa fa-plus mx-2 inline-block"></i>
    Add text element
  </button>
</div>
